import { PERMISSION_SCOPE_ALL_TEAMS_ID } from '@linearb/linjs-common';
import _ from 'lodash';

// get accounts with one scope that are in the current team that isn't all teams
const getAccountsInCurrentTeam = (accounts, teamId) =>
  accounts.filter(account => {
    const accountScopes = _.get(account, 'account_scopes', []);
    const accountScopesids = _.keyBy(accountScopes, 'scope_id');
    const isAllTeams = !!accountScopesids[PERMISSION_SCOPE_ALL_TEAMS_ID];
    if (accountScopes.length === 1 && !isAllTeams) {
      const accountScopeid = _.get(accountScopes[0], 'scope_id');
      return accountScopeid === teamId;
    }
  });

export const getAccountsNamesFormatted = (accounts, teamId) => {
  const accountsInCurrentTeam = getAccountsInCurrentTeam(accounts, teamId);

  return accountsInCurrentTeam.map((account, i) => {
    const name = _.get(account, 'name', '');
    if (i === accountsInCurrentTeam.length - 1) {
      return name;
    }
    return name + ',';
  });
};
